/**
 * Epoch milliseconds at which a JWT access token expires, or null when no `exp`
 * claim can be read.
 *
 * Returns the claim rather than a verdict because the two callers want opposite
 * answers for an unreadable token: an impersonation session is discarded, while
 * an outbound request still sends it and lets the server rule on it.
 */
export function getAccessTokenExpiry(accessToken: string): number | null {
  try {
    const payloadBase64 = accessToken.split('.')[1];
    if (!payloadBase64) return null;
    const payload = JSON.parse(atob(payloadBase64)) as { exp?: number };
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

/** Whether a JWT's `exp` claim is in the past. Unreadable tokens count as expired. */
export function isAccessTokenExpired(accessToken: string): boolean {
  const expiry = getAccessTokenExpiry(accessToken);
  return expiry === null || expiry < Date.now();
}
